import { render, staticRenderFns } from "./WCrud.vue?vue&type=template&id=4a4b5fdf&scoped=true&lang=pug&"
import script from "./WCrud.vue?vue&type=script&lang=js&"
export * from "./WCrud.vue?vue&type=script&lang=js&"
import style0 from "./WCrud.vue?vue&type=style&index=0&id=4a4b5fdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b5fdf",
  null
  
)

export default component.exports